import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'

import styles from './SyllabusHeader.module.scss'

const SyllabusHeader = ({ syllabus, status, saving, onSave, onSubmit }) => {
  const { t } = useTranslation('common')

  return (
    <div className={`unv-card ${styles.header}`}>
      <div>
        <h1 className={styles.title}>{syllabus.title || t('syllabus.default_title')}</h1>
        <span className={`unv-badge ${status.cls}`}>{status.label}</span>
      </div>
      <div className={styles.actions}>
        <Button variant="outlined" onClick={onSave} disabled={saving}>
          {t('syllabus.save_btn')}
        </Button>
        <Button variant="contained" onClick={onSubmit} disabled={syllabus.status === 'pending'}>
          {t('syllabus.submit_for_approval')}
        </Button>
      </div>
    </div>
  )
}

export default SyllabusHeader
